(function () {
  // Safari ke liye sabse pehle set karo
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

  var STORE = 'collection_restore:';
  var loading = false;
  var restoring = true;
  var observer = null;
  var maxPage = 1;               // abhi tak kitne pages load hue

  function grid()  { return document.querySelector('.products-on-page'); }
  function btn()   { return document.querySelector('.load-more_btn'); }
  function spin()  { return document.querySelector('.load-more_spinner'); }
  function nextLink() { return document.querySelector('#Huratips-Pagination a'); }

  function baseKey() {
    var u = new URL(location.href);
    u.searchParams.delete('page');
    return STORE + u.pathname + u.search;
  }
  function currentPage() {
    return parseInt(new URL(location.href).searchParams.get('page') || '1', 10) || 1;
  }
  function pageFromHref(href) {
    return parseInt(new URL(href, location.origin).searchParams.get('page') || '1', 10) || 1;
  }
  function pageUrl(p) {
    var u = new URL(location.href);
    u.searchParams.set('page', p);
    return u.toString();
  }
  function readSaved() {
    var s = null;
    try { s = JSON.parse(sessionStorage.getItem(baseKey()) || 'null'); } catch (e) {}
    if (s && Date.now() - s.t > 30 * 60 * 1000) s = null;
    return s;
  }

  async function fetchHtml(url) {
    var res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Load fail: ' + url);
    var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    var g = doc.querySelector('.products-on-page');
    var n = doc.querySelector('#Huratips-Pagination a');
    return {
      items: g ? Array.prototype.slice.call(g.children) : [],
      nextHref: n ? n.getAttribute('href') : null
    };
  }

  function setNext(href) {
    var link = nextLink();
    if (href) {
      if (link) link.setAttribute('href', href);
    } else {
      if (link) link.remove();
      if (btn()) btn().style.display = 'none';
      if (observer) observer.disconnect();
    }
  }

  // URL + history state dono me page number
  function setUrlPage(p) {
    var u = new URL(location.href);
    if (p > 1) u.searchParams.set('page', p); else u.searchParams.delete('page');
    history.replaceState(p > 1 ? { crPage: p } : null, '', u.toString());
  }

  // ---------- SEE MORE ----------
  window.loadMoreProducts = async function () {
    var link = nextLink(), g = grid(), b = btn();
    if (loading || !link || !g || !b) return;
    var href = link.getAttribute('href');
    if (!href) return;

    loading = true;
    if (spin()) spin().style.display = 'block';
    try {
      var data = await fetchHtml(href);
      var frag = document.createDocumentFragment();
      data.items.forEach(function (li) { frag.appendChild(li); });
      g.appendChild(frag);
      setNext(data.nextHref);
      maxPage = pageFromHref(href);
      setUrlPage(maxPage);
    } catch (e) {
      console.error(e);
    } finally {
      loading = false;
      if (spin()) spin().style.display = 'none';
      if (observer && btn() && nextLink()) { observer.unobserve(btn()); observer.observe(btn()); }
    }
  };

  // ---------- Product click par state save ----------
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.products-on-page a[href*="/products/"]');
    if (!a) return;
    var g = grid();
    var nl = nextLink();
    var payload = {
      page: maxPage,
      path: new URL(a.getAttribute('href'), location.origin).pathname,
      y: window.scrollY,
      t: Date.now(),
      next: nl ? nl.getAttribute('href') : null,
      html: g ? g.innerHTML : ''
    };
    try {
      sessionStorage.setItem(baseKey(), JSON.stringify(payload));
    } catch (err) {
      delete payload.html;   // storage full: network fallback chalega
      try { sessionStorage.setItem(baseKey(), JSON.stringify(payload)); } catch (e2) {}
    }
  }, true);

  // ---------- Page load ----------
  async function init() {
    var g = grid();
    if (!g) { restoring = false; return; }

    var page = currentPage();
    var statePage = (history.state && history.state.crPage) || 0;
    var nav = performance.getEntriesByType('navigation')[0];
    var isBack = (nav && nav.type === 'back_forward') || statePage > 0;
    var saved = readSaved();

    // URL, history state, saved: teeno me se sabse bada page
    var target = Math.max(page, statePage);
    if (isBack && saved && saved.page > target) target = saved.page;
    maxPage = target;

    if (isBack && saved && saved.html && saved.page >= target) {
      // FAST PATH: cache se turant
      g.innerHTML = saved.html;
      setNext(saved.next);
      maxPage = saved.page;
      setUrlPage(saved.page);
    } else if (target > 1) {
      // FALLBACK: pages parallel fetch
      document.documentElement.classList.add('cr-pending');
      if (spin()) spin().style.display = 'block';
      try {
        var before = [], after = [];
        for (var q = 1; q < page; q++) before.push(fetchHtml(pageUrl(q)));
        for (var p = page + 1; p <= target; p++) after.push(fetchHtml(pageUrl(p)));
        var res = await Promise.all([Promise.all(before), Promise.all(after)]);

        var f1 = document.createDocumentFragment();
        res[0].forEach(function (r) { r.items.forEach(function (li) { f1.appendChild(li); }); });
        g.insertBefore(f1, g.firstChild);

        var f2 = document.createDocumentFragment();
        res[1].forEach(function (r) { r.items.forEach(function (li) { f2.appendChild(li); }); });
        g.appendChild(f2);

        if (res[1].length) setNext(res[1][res[1].length - 1].nextHref);
        setUrlPage(target);
      } catch (e) { console.error(e); }
    }

    if (isBack && saved) restoreScroll(g, saved);

    if (spin()) spin().style.display = '';
    document.documentElement.classList.remove('cr-pending');
    setTimeout(function () { restoring = false; startObserver(); }, 500);
  }

  // ---------- Scroll restore ----------
  function restoreScroll(g, saved) {
    var de = document.documentElement;

    function go() {
      var links = g.querySelectorAll('a[href*="/products/"]');
      var a = Array.prototype.find.call(links, function (x) {
        return new URL(x.getAttribute('href'), location.origin).pathname === saved.path;
      });
      var li = a && a.closest('li');
      var prev = de.style.scrollBehavior;
      de.style.scrollBehavior = 'auto';
      if (li) {
        var r = li.getBoundingClientRect();
        var top = r.top + window.pageYOffset - (window.innerHeight / 2 - r.height / 2);
        window.scrollTo(0, Math.max(0, top));
      } else {
        window.scrollTo(0, saved.y || 0);
      }
      de.style.scrollBehavior = prev;
    }

    var stop = false;
    function cancel() { stop = true; }
    window.addEventListener('touchstart', cancel, { once: true, passive: true });
    window.addEventListener('wheel', cancel, { once: true, passive: true });

    go();
    [250, 800].forEach(function (ms) {
      setTimeout(function () { if (!stop) go(); }, ms);
    });
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () { if (!stop) go(); });
    }
  }

  // ---------- Safari swipe-back (bfcache) ----------
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var g = grid(), saved = readSaved();
    if (g && saved) restoreScroll(g, saved);
  });

  // ---------- Auto-load ----------
  function startObserver() {
    var b = btn();
    if (!b || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !loading && !restoring) window.loadMoreProducts();
    }, { rootMargin: '200px 0px' });
    observer.observe(b);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();



// function loadMoreProducts() {
//   $('button.load-more_btn.btn').attr('disabled',true);
//  var products_on_page = $(".products-on-page");
// var next_url = $('#Huratips-Pagination a').attr("href");
//     // var paramString = next_url.split('?')[1];
//     //   var pagenext_url=paramString.replace('page','cpage');
//  if(next_url!='' && next_url != 'undefined'){  
// var load_more_btn = $(".load-more_btn ");
// var load_more_spinner = $(".load-more_spinner");
//   $.ajax({
//     url: next_url,
//     type: "GET",
//     dataType: "html",
//     beforeSend: function () {
//       load_more_btn.hide();
//       load_more_spinner.show();
//     },
//   }).done(function (next_page) {
//     load_more_spinner.hide();
//    var new_products = $(next_page).find(".products-on-page");
//     var new_url = $(next_page).find('#Huratips-Pagination a').attr("href");
//      $('#Huratips-Pagination a').attr("href",new_url);
//      $('.pagination_number').attr("next-url");
//     if (new_url) load_more_btn.show();
//     products_on_page.append(new_products.html());
//    $('button.load-more_btn.btn').attr('disabled',false);
//     // window.history.replaceState({ }, '', `https://www.westcoastwalls.ca/collections/for-kids-wallpaper?${pagenext_url}`);
//   });
//  }
// }
// function isInView(elem){
//     console.log($(elem).offset().top - $(window).scrollTop())
//    return $(elem).offset().top - $(window).scrollTop() < 800 && $(elem).offset().top - $(window).scrollTop() >0;
    
// }
// $(window).scroll(function(){
//    if(isInView($('.load-more .load-more_btn')) ==  true){
       
//        $('.load-more .load-more_btn').trigger('click');
//    }
// })




